import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SkipKidsAndAgeRateFilterService {
  private _ageFilterSkippingComponents: object[] = [];

  public shouldSkipFiltering(): boolean {
    return !!this._ageFilterSkippingComponents.length;
  }

  public addAgeFilterSkippingComponent(component: object) {
    this._ageFilterSkippingComponents.push(component);
  }

  public removeAgeFilterSkippingComponent(component: object): void {
    if (this._ageFilterSkippingComponents.includes(component)) {
      this._ageFilterSkippingComponents = this._ageFilterSkippingComponents.filter((it) => it !== component);
    }
  }
}
